// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderLogo_wrapper__wCsLi","logo":"HeaderLogo_logo__o6rdz"};